<template>
  <SoAlert
    v-if="openDcaTickets.length > 0"
    class="mx-5 my-5"
    type="error"
    data-testid="dca-banner-alert"
  >
    <SoRow>
      <SoCol :default-width="8">
        <h6>
          This account has been placed with a Debt Collection Agency ({{
            dcaName
          }}). Advise the customer they should continue engaging with them to
          pay off their debt.
        </h6>
      </SoCol>
      <SoCol :default-width="4" class="text-right">
        <SoButton
          title="DCA guide"
          large
          data-testid="dca-guide"
          type="inverted"
          @click="openDCAGuide()"
        />
      </SoCol>
    </SoRow>
  </SoAlert>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoAlert from "@/components/SoAlert.vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoCol from "@/components/SoCol.vue"
  import SoRow from "@/components/SoRow.vue"
  import { DcaConfigurationService } from "@/services/DcaConfigurationService"
  import { externalRoutes } from "@/constants/routes/externalRoutes"

  export default defineComponent({
    components: {
      SoAlert,
      SoButton,
      SoCol,
      SoRow,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
      }
    },
    computed: {
      openDcaTickets() {
        const openJuniferTickets = this.current.juniferTickets.data.filter(
          (ticket) => ticket.statusText === "Open",
        )

        return openJuniferTickets
          .filter((ticket) => ticket.summary?.includes("assigned to DCA"))
          .sort((a, b) => b.createdDate.valueOf() - a.createdDate.valueOf())
      },
      dcaName() {
        const dcaNames = DcaConfigurationService.getConfiguration().data.map(
          (dca) => dca.name,
        )

        return (
          dcaNames.find((name) => this.openDcaTickets[0].name.includes(name)) ||
          ""
        )
      },
    },
    methods: {
      openDCAGuide() {
        window.open(externalRoutes.DCAGuide.path)
      },
    },
  })
</script>
